export const isInStock = (status: string): boolean => /^IN_STOCK$/i.test(status);
